import "./AboutView.css";

import Component from "../components/Component";
import { newElement } from "../Dom";

export default class AboutView extends Component {

    connectedCallback(): void {
        this.replaceChildren(
            newElement("p", {
                text: "Can't pick your class for the upcoming World of Warcraft game? "
                    + "I got you covered. Let RNG decide your destiny.",
            }),
            newElement("p", {
                text: "Two wheels, one verdict. Spin the left/top one for a race and the right/bottom one "
                    + "for a class. "
            }),
            this.nameTip(),
            newElement("p", {
                text: "Disclaimer: Not affiliated with Blizzard Entertainment in any way, shape or form. This is purely fan-made."
            })
        );
    }

    private nameTip(): HTMLParagraphElement {
        const paragraph = newElement("p", {
            text: "Still stuck on a name? If the wheels give you a Troll Shaman, the answer is ",
        });

        paragraph.append(
            newElement("strong", { text: "Thex" }),
            ". And if you get skyborne... Just reroll. "
        );

        return paragraph;
    }
}

customElements.define("about-view", AboutView);
